import React from "react";
import { connect } from 'react-redux';
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from 'react-router-dom';
import { postFolder } from "../Actions/ControlledDocAPI";
import $ from "jquery";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

class ControlledDocAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            folderinfo: {
                folderName: "",
                createdBy: currentuser.name,
            }
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
    }

    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "Controlled Documents" });
    }

    handleInputChange(e) {
        this.state.folderinfo.folderName = e.target.value;
        this.setState({});
    }

    ClearInput() {
        this.state.folderinfo.folderName = "";
        this.setState({});
    }
    AddFolder() {
        const { dispatch,t } = this.props;
        if (this.state.folderinfo?.folderName?.trim() !== ""){
        console.log("add")
        this.props.dispatch(postFolder(this.state.folderinfo, this.props.history,t));
        } else {
        console.log("error")
        $("#FolderErrorMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
        }
    }

    render() {
        const{t}=this.props;
        return (
            <div className="pb-3">
                <div className="full-height">
                    <div className="resource-list-auth-date row pt-3 ">
                        <div className='col-lg-12'>
                            <div className="panel-box">
                                <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>{t("ControlledDocumentsScreenContent.AddFolder")}</h5>
                                    </div>
                                </div>
                                <div className="row search-filter-box">
                                    <div className="col-lg-6">
                                        <label className="form-label">{t("ControlledDocumentsScreenContent.FolderName")}</label>
                                        <br></br>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="folder"
                                            value={this.state.folderinfo.folderName}
                                            placeholder={t("ControlledDocumentsScreenContent.Folder")}
                                            onChange={e => this.handleInputChange(e)}
                                        ></input>
                                         <span id="FolderErrorMsg" className="spanErrMsg"></span>
                                    </div>
                                </div>
                                <div className="search-filter-box">
                                    <div className="col-lg-12 search-filter-box">
                                        <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.AddFolder()}> {t("ComplianceandBudgetScreen.Submit")} </button>

                                            <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> {t("ComplianceandBudgetScreen.Cancel")} </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        );
    }
    
hideSidePanel() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/ControlledDocuments");
}
}


function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        FlagAttachment: state.lookupReducer.FlagAttachment,
        EquipmentNameListAndId: state.MasterScreenReducer.EquipmentNameListAndId || [],
        applicableServiceType: state.MasterScreenReducer.applicableServiceTypeInterval,
        FlagApplicableServices: state.MasterScreenReducer.FlagApplicableServices,
    }
}
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(ControlledDocAdd)));